// Money formatting and the simple rules of thumb used by the site's tools.
// None of these are advice: every screen that shows them says so.

export const inr = (n) => '₹' + Math.round(n).toLocaleString('en-IN');

// ₹12 L / ₹2.5 Cr (₹12 লাখ in Bengali); below a lakh, the full amount.
export const short = (n, lang = 'en') => {
  if (n >= 1e7) return '₹' + (n / 1e7).toFixed(2).replace(/\.?0+$/, '') + ' Cr';
  if (n >= 1e5) return '₹' + (n / 1e5).toFixed(1).replace(/\.0$/, '') + (lang === 'bn' ? ' লাখ' : ' L');
  return inr(n);
};

// Future value of a monthly SIP paid at the start of each month (same formula as the old site).
export const sipValue = (monthly, annualPct, years) => {
  const i = annualPct / 100 / 12;
  const m = years * 12;
  if (i === 0) return monthly * m;
  return monthly * ((Math.pow(1 + i, m) - 1) / i) * (1 + i);
};

export const lumpValue = (amount, annualPct, years) => amount * Math.pow(1 + annualPct / 100, years);

// Family floater in lakh: ₹5 L / ₹10 L / ₹15 L base for small town / Kolkata / metro,
// +25% per member beyond two, rounded UP to the next ₹5 L (policies come in ₹5 L steps), between ₹5 L and ₹50 L.
export const healthCover = (members, cityTier) => {
  const base = cityTier === 1 ? 5 : cityTier === 2 ? 10 : 15;
  const lakh = Math.ceil((base * (1 + Math.max(0, members - 2) * 0.25)) / 5) * 5;
  return Math.min(50, Math.max(5, lakh));
};

// Life cover in rupees: yearly income × 15 (under 35) / 12 (35–44) / 10 (45+), × 5 with no dependants,
// rounded to ₹5 L.
export const lifeCover = ({ age, monthlyIncome, dependants }) => {
  const mult = dependants === 0 ? 5 : age < 35 ? 15 : age < 45 ? 12 : 10;
  return Math.round((monthlyIncome * 12 * mult) / 500000) * 500000;
};
